import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import { dateTimeReportFormatter } from "../../fomatters/DateFormatter";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import InputSelect from "../InputSelect";
import ReportByGame from "../ReportByGame";
import SubGroup from "../SubGroup";
import _ from "lodash";

const startDateValue = new Date().toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function TimeStatusChanges() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [option, setOption] = useState(0);
  const onOptionChange = useCallback(
    (event) => setOption(Number(event.target.value)),
    []
  );

  const [sport, setSport] = useState("");
  const onSportChanged = useCallback((s) => setSport(s), []);
  const { values: sports } = useDataFormatterHook({
    addEmpty: true,
    value: "idSport",
    text: "sportName",
    path: `/Player/GetSports`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Sport"
          name="name"
          data={sports}
          placeholder="DataFormatter"
          setSelectValue={onSportChanged}
          startValue={""}
        />

        <div>
          <SubGroup title="Changes On">
            <FormControl component="fieldset">
              <RadioGroup label value={option} onChange={onOptionChange} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Status"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Score"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Time"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
      </div>
      <ReportByGame
        omitGroup
        title="Time-Status Changes Report"
        getUrl={() => "/Reports/Report_Game_Status_Changes_2"}
        getPostProcess={(groupedData) => {
          const items = Object.values(groupedData).map((Values) => {
            const [{ lastModification }] = Values;

            return {
              lastModification: new Date(lastModification),
              Values,
            };
          });

          return _.orderBy(items, ["lastModification"]);
        }}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          Sport: sport,
          Option: option,
        })}
        getProcess={(sport, values) => {
          switch (sport) {
            case "tnt": {
              const {
                Id,
                idSport,
                visitorNumber,
                visitorTeam,
                lastModification,
                loginName,
                oldStatus,
                newStatus,
              } = values?.[0];
              return [
                {
                  Id: `${Id}V`,
                  sport: idSport,
                  team: `${visitorNumber ?? ""} ${visitorTeam ?? ""}`,
                  date: lastModification,
                  user: loginName,
                  from: oldStatus,
                  to: newStatus,
                },
              ];
            }
            default: {
              const {
                Id,
                idSport,
                homeNumber,
                homeTeam,
                homePitcher,
                visitorNumber,
                visitorTeam,
                visitorPitcher,
                lastModification,
                loginName,
                oldStatus,
                newStatus,
              } = values?.[0];
              const mlb = sport === "mlb";
              return [
                {
                  Id: `${Id}V`,
                  sport: idSport,
                  team: mlb
                    ? `${visitorNumber ?? ""} ${visitorTeam ?? ""} (${visitorPitcher ?? ""
                    })`
                    : `${visitorNumber ?? ""} ${visitorTeam ?? ""}`,
                  date: lastModification,
                  user: loginName,
                  from: oldStatus,
                  to: newStatus,
                },
                {
                  Id: `${Id}H`,
                  sport: "",
                  team: mlb
                    ? `${homeNumber ?? ""} ${homeTeam ?? ""} (${homePitcher ?? ""
                    })`
                    : `${homeNumber ?? ""} ${homeTeam ?? ""}`,
                  date: "",
                  user: "",
                  from: "",
                  to: "",
                },
              ];
            }
          }
        }}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="sport">
          Sport
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="team">
          Game
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="date"
          dataFormat={dateTimeReportFormatter}
        >
          Change Time
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="user">
          User
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="from">
          Change From
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="to">
          To
        </TableHeaderColumn>
      </ReportByGame>
    </div>
  );
}

export default TimeStatusChanges;
